import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faTags,
  faGlasses,
  faChevronCircleLeft,
  faPlay,
  faStop,
  faSave,
  faExchangeAlt,
  faTrashRestore,
  faPlusCircle,
  faMinusCircle,
  faRecycle,
  faRedoAlt,
  faUndoAlt,
  faTag,
  faPaperPlane,
  faAlignLeft,
  faAlignRight,
  faAlignJustify,
  faReply,
  faEquals,
  faNotEqual,
  faGreaterThan,
  faGreaterThanEqual,
  faLessThan,
  faLessThanEqual,
  faTimes,
  faDivide,
  faPlus,
  faMinus,
  faExclamationTriangle,
  faInfo,
  faLink,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faTags,
  faGlasses,
  faChevronCircleLeft,
  faPlay,
  faStop,
  faSave,
  faExchangeAlt,
  faTrashRestore,
  faPlusCircle,
  faMinusCircle,
  faRecycle,
  faRedoAlt,
  faUndoAlt,
  faTag,
  faPaperPlane,
  faAlignLeft,
  faAlignRight,
  faAlignJustify,
  faReply,
  faEquals,
  faNotEqual,
  faGreaterThan,
  faGreaterThanEqual,
  faLessThan,
  faLessThanEqual,
  faTimes,
  faDivide,
  faPlus,
  faMinus,
  faExclamationTriangle,
  faInfo,
  faLink
)
Vue.component('font-awesome-icon', FontAwesomeIcon)
